import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-clockimage',
  templateUrl: './clockImage.component.html',
  styleUrls: ['../IconDesings.scss'],
})

export class ClockImageComponent {
  constructor() {
  }
}